import { GridOptions } from '@ag-grid-community/core';
import i18next from 'i18next';

import { defaultDataTableOptions } from '../constants';
import { IDataTableOptions } from '../data-table-properties';

const baseGridOptions = (
  labelsNamespace: string,
  {
    showFloatingFilter,
    showAggFuncInHeader,
    enableGrouping,
    pageSize,
    groupColumnDef,
    getRowNodeId,
    serverSideStoreType,
  }: IDataTableOptions,
): GridOptions => ({
  rowModelType: 'serverSide',
  serverSideSortingAlwaysResets: true,
  serverSideFilteringAlwaysResets: true,
  serverSideStoreType,

  localeTextFunc: (key, defaultValue) => i18next.t([`${labelsNamespace}.${key}`, defaultValue]),

  getRowNodeId,
  autoGroupColumnDef: groupColumnDef,
  suppressAggFuncInHeader: !showAggFuncInHeader,

  pagination: true,
  paginationPageSize: pageSize,
  defaultColDef: {
    flex: 1,
    minWidth: 100,
    sortable: true,
    filter: true,
    floatingFilter: showFloatingFilter,
    menuTabs: ['generalMenuTab'],
    resizable: true,
    enableRowGroup: enableGrouping,
  },
  sideBar: {
    toolPanels: [
      {
        id: 'columns',
        labelDefault: 'Columns',
        labelKey: 'columns',
        iconKey: 'columns',
        toolPanel: 'agColumnsToolPanel',
        toolPanelParams: {
          suppressRowGroups: !enableGrouping,
          suppressValues: true,
          suppressPivots: true,
          suppressPivotMode: true,
          suppressSideButtons: true,
          suppressColumnFilter: false,
          suppressColumnSelectAll: false,
          suppressColumnExpandAll: true,
        },
      },
    ],
  },
  suppressContextMenu: true,
});

export const generateOptions = (
  labelsNamespace,
  options?: GridOptions,
  dataTableOptions: IDataTableOptions = defaultDataTableOptions,
): GridOptions => {
  const ret = Object.assign({}, baseGridOptions(labelsNamespace, dataTableOptions), options || {});

  if (!dataTableOptions.showSidebar) delete ret.sideBar;
  return ret;
};
